export function formatHashChannel(channel) {
  return `$${channel && channel.replace(/\W/g, '')}`
}
